import dark from './dark';
import light from './light';
export { default as STATIC_ICONS } from './static';

const icons = {
	dark,
	white: light,
};

export default icons;
